import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

type GridLayoutThreeIconProps = IconClientSVGProps & {
  filled?: boolean;
};

export const GridLayoutThreeIcon = forwardRef<
  SVGSVGElement,
  GridLayoutThreeIconProps
>(({ filled, label, ...props }, ref) => {
  return (
    <Icon label={label}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        ref={ref}
        {...props}
      >
        {filled ? (
          <>
            <path d="M2 11H6V18H2V11Z" fill="currentColor" />
            <path d="M8 11H12V18H8V11Z" fill="currentColor" />
            <path d="M14 11H18V18H14V11Z" fill="currentColor" />
            <path d="M2 2H6V9H2V2Z" fill="currentColor" />
            <path d="M8 2H12V9H8V2Z" fill="currentColor" />
            <path d="M14 2H18V9H14V2Z" fill="currentColor" />
            <path d="M2 11H6V18H2V11Z" stroke="currentColor" />
            <path d="M8 11H12V18H8V11Z" stroke="currentColor" />
            <path d="M14 11H18V18H14V11Z" stroke="currentColor" />
            <path d="M2 2H6V9H2V2Z" stroke="currentColor" />
            <path d="M8 2H12V9H8V2Z" stroke="currentColor" />
            <path d="M14 2H18V9H14V2Z" stroke="currentColor" />
          </>
        ) : (
          <>
            <path d="M2 10.7083H6.24513V18H2V10.7083Z" stroke="currentColor" />
            <path
              d="M7.75255 10.7083H12.2846V18H7.75255V10.7083Z"
              stroke="currentColor"
            />
            <path
              d="M13.728 10.7083H18V18H13.728V10.7083Z"
              stroke="currentColor"
            />
            <path d="M2 2H6.24513V9.2662H2V2Z" stroke="currentColor" />
            <path
              d="M7.75255 2H12.2846V9.2662H7.75255V2Z"
              stroke="currentColor"
            />
            <path d="M13.728 2H18V9.2662H13.728V2Z" stroke="currentColor" />
          </>
        )}
      </svg>
    </Icon>
  );
});

GridLayoutThreeIcon.displayName = "GridLayoutThreeIcon";
